/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, AsatDto } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    AsatDtoFromJSON,
    AsatDtoToJSON,
} from "../models/index";

export interface GetAsatRequest {
    deviceIdentity: string;
}

export interface ResetAsatConnectorResultRequest {
    deviceIdentity: string;
    chargerUniqueId: string;
    connectorNumber: number;
}

export interface ResetAsatPowerMeterResultRequest {
    deviceIdentity: string;
    powerMeterUniqueId: string;
}

export interface StartAsatRequest {
    deviceIdentity: string;
}

export interface StopAsatRequest {
    deviceIdentity: string;
}

/**
 *
 */
export class AsatHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get the current ASAT run for the given device identity.
     */
    async getAsatRaw(
        requestParameters: GetAsatRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<AsatDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getAsat().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/automatic-site-acceptance-test`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            AsatDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get the current ASAT run for the given device identity.
     */
    async getAsat(
        requestParameters: GetAsatRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<AsatDto> {
        const response = await this.getAsatRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Reset a connector result back to Pending so it can be re-tested.
     */
    async resetAsatConnectorResultRaw(
        requestParameters: ResetAsatConnectorResultRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling resetAsatConnectorResult().',
            );
        }

        if (requestParameters["chargerUniqueId"] == null) {
            throw new runtime.RequiredError(
                "chargerUniqueId",
                'Required parameter "chargerUniqueId" was null or undefined when calling resetAsatConnectorResult().',
            );
        }

        if (requestParameters["connectorNumber"] == null) {
            throw new runtime.RequiredError(
                "connectorNumber",
                'Required parameter "connectorNumber" was null or undefined when calling resetAsatConnectorResult().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/connector-results/{chargerUniqueId}/{connectorNumber}/reset`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"chargerUniqueId"}}`,
                        encodeURIComponent(
                            String(requestParameters["chargerUniqueId"]),
                        ),
                    )
                    .replace(
                        `{${"connectorNumber"}}`,
                        encodeURIComponent(
                            String(requestParameters["connectorNumber"]),
                        ),
                    ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Reset a connector result back to Pending so it can be re-tested.
     */
    async resetAsatConnectorResult(
        requestParameters: ResetAsatConnectorResultRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.resetAsatConnectorResultRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Reset a power meter result back to Pending so it can be re-tested.
     */
    async resetAsatPowerMeterResultRaw(
        requestParameters: ResetAsatPowerMeterResultRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling resetAsatPowerMeterResult().',
            );
        }

        if (requestParameters["powerMeterUniqueId"] == null) {
            throw new runtime.RequiredError(
                "powerMeterUniqueId",
                'Required parameter "powerMeterUniqueId" was null or undefined when calling resetAsatPowerMeterResult().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/power-meter-results/{powerMeterUniqueId}/reset`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"powerMeterUniqueId"}}`,
                        encodeURIComponent(
                            String(requestParameters["powerMeterUniqueId"]),
                        ),
                    ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Reset a power meter result back to Pending so it can be re-tested.
     */
    async resetAsatPowerMeterResult(
        requestParameters: ResetAsatPowerMeterResultRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.resetAsatPowerMeterResultRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Start the ASAT run for the given device identity (idempotent — returns the current run if already started).
     */
    async startAsatRaw(
        requestParameters: StartAsatRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<AsatDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling startAsat().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/automatic-site-acceptance-test/start`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            AsatDtoFromJSON(jsonValue),
        );
    }

    /**
     * Start the ASAT run for the given device identity (idempotent — returns the current run if already started).
     */
    async startAsat(
        requestParameters: StartAsatRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<AsatDto> {
        const response = await this.startAsatRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Stop the in-progress ASAT run for the given device identity.
     */
    async stopAsatRaw(
        requestParameters: StopAsatRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling stopAsat().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/automatic-site-acceptance-test/stop`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Stop the in-progress ASAT run for the given device identity.
     */
    async stopAsat(
        requestParameters: StopAsatRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.stopAsatRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
